import React, { Component } from "react";
import Wherewe from "../organisms/Wherewe";
import Clients from "../organisms/Clients";
import Header from "../organisms/Header";
import Contactus from "../organisms/Contactus";
import Footer from "../organisms/Footer";
import Cases from "../organisms/Cases";
import WeBring from "../organisms/WeBring";
import Messages from "../organisms/Messages";
import BlogExcerpt from "../organisms/BlogExcerpt";
import { Helmet } from "react-helmet";

class Home extends Component {
  render() {
    return (
      <div className="template">
        <Helmet>
          <meta
            name="description"
            content="Digital solutions partner. High quality work with Symfony, React and Elixir"
          />
          <title>
            Limenius. Development, training, consulting with React, Symfony and
            Elixir.
          </title>
        </Helmet>
        <Messages />
        <div id="ourwork" />
        <Cases />
        <WeBring />
        <BlogExcerpt
          md={this.props.data.allMarkdownRemark}
          json={this.props.data.allPostsJson}
        />
        <Wherewe
          images={{
            alicante: this.props.data.alicante,
            munich: this.props.data.munich
          }}
        />
        <Clients
          images={{
            pccomponentes: this.props.data.pccomponentes,
            clubvillamar: this.props.data.clubvillamar,
            miequipo: this.props.data.miequipo,
            tiptoc: this.props.data.tiptoc,
            trecetas: this.props.data.trecetas,
            interacso: this.props.data.interacso,
            dpool: this.props.data.dpool,
            iukanet: this.props.data.iukanet,
            leyelectoral: this.props.data.leyelectoral,
            ultreia: this.props.data.ultreia,
            travedoc: this.props.data.travedoc,
            dietopro: this.props.data.dietopro,
            makoondi: this.props.data.makoondi,
            goodman: this.props.data.goodman,
            pandemicquiz: this.props.data.pandemicquiz,
            alchemist: this.props.data.alchemist,
            aulaplus: this.props.data.aulaplus
          }}
        />
        <div id="contactus" />
        <Contactus />
      </div>
    );
  }
}

export default Home;

export const query = graphql`
  query ImagesAndPostsQuery {
    allPostsJson {
      edges {
        node {
          excerpt
          date(formatString: "DD MMM, YYYY")
          page
          title
          author
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          frontmatter {
            title
            author
            date(formatString: "DD MMM, YYYY")
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
    alicante: file(relativePath: { eq: "alicante.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 348) {
          ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
    munich: file(relativePath: { eq: "munich.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 347) {
          ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
    pccomponentes: file(relativePath: { eq: "clients/pccomponentes.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    clubvillamar: file(relativePath: { eq: "clients/clubvillamar.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    miequipo: file(relativePath: { eq: "clients/miequipo.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    tiptoc: file(relativePath: { eq: "clients/tiptoc.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    trecetas: file(relativePath: { eq: "clients/trecetas.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    interacso: file(relativePath: { eq: "clients/interacso.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    dpool: file(relativePath: { eq: "clients/dpool.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    iukanet: file(relativePath: { eq: "clients/iukanet.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    leyelectoral: file(relativePath: { eq: "clients/leyelectoral.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    ultreia: file(relativePath: { eq: "clients/ultreia.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    dietopro: file(relativePath: { eq: "clients/dietopro.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    makoondi: file(relativePath: { eq: "clients/makoondi.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    pandemicquiz: file(relativePath: { eq: "clients/pandemicquiz.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    alchemist: file(relativePath: { eq: "clients/alchemist.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
    aulaplus: file(relativePath: { eq: "clients/aulaplus.png" }) {
      childImageSharp {
        resolutions(width: 175, height: 55) {
          ...GatsbyImageSharpResolutions_tracedSVG
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js